import { createStore as createZustandStore, type StateCreator, type StoreApi } from 'zustand/vanilla';

type CreateStoreOptions = {
  /**
   * Every store holds data of the active partner (the account picked in the user menu) unless it
   * says otherwise here. Only the session itself (who is logged in, which accounts exist) survives
   * an account switch.
   */
  keepOnPartnerSwitch?: boolean;
};

const partnerScopedStores = new Set<StoreApi<unknown>>();

export function createStore<TState>(
  initializer: StateCreator<TState, [], [], TState>,
  options: CreateStoreOptions = {},
): StoreApi<TState> {
  const store = createZustandStore<TState>()(initializer);
  if (options.keepOnPartnerSwitch !== true) {
    partnerScopedStores.add(store as StoreApi<unknown>);
  }
  return store;
}

/**
 * Puts every partner-scoped store back to its initial state. Called on an account switch BEFORE
 * the new partner reaches the auth store, so no screen renders the previous account's data under
 * the new account's name, and every "already loaded" guard starts empty again.
 */
export function resetPartnerScopedStores(): void {
  partnerScopedStores.forEach((store) => {
    store.setState(store.getInitialState(), true);
  });
}
